const bundle = {
  close: () => 'Schließen',
  error: () => 'Fehler',
  warn: () => 'Warnung',
  info: () => 'Info',
  confirmation: () => 'Bestätigung',
  progressIndeterminate: () => 'Wird ausgeführt',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Zwischen ' + p['FROM_SECTION'] + ' und ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Kein übereinstimmender Abschnitt gefunden.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Drücken Sie die Eingabetaste, um einen Wert auszuwählen.',
  indexer_touchInstructionText: () =>
    'Doppeltippen und halten, um den Gestenmodus aufzurufen, und anschließend nach oben oder unten ziehen, um den Wert anzupassen.',
  inputPassword_show: () => 'Kennwort anzeigen',
  inputPassword_hide: () => 'Kennwort ausblenden',
  inputPassword_hidden: () => 'Kennwort ausgeblendet',
  formControl_clear: () => 'Leeren',
  formControl_loading: () => 'Wird geladen',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maximale Länge ' + p['MAX_LENGTH'] + ' überschritten.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' Zeichen übrig.',
  select_noMatchesFound: () => 'Keine Übereinstimmungen gefunden.',
  select_oneMatchFound: () => 'Eine Übereinstimmung gefunden',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' Übereinstimmungen gefunden',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' oder mehr Übereinstimmungen gefunden',
  selectMultiple_showSelectedValues: () => 'Nur ausgewählte Werte anzeigen.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' Werte ausgewählt.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'Kontrollkästchen aktiviert',
  selector_unselected: () => 'Kontrollkästchen nicht aktiviert',
  userAssistance_learnMore: () => 'Weitere Informationen',
  userAssistance_required: () => 'Erforderlich',
  filePicker_singleFileUploadError: () => 'Laden Sie jeweils nur eine Datei hoch',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Sie können keine Dateien des Typs ' + p['fileType'] + ' hochladen',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Sie können keine Dateien des folgenden Typs hochladen: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'unbekannt',
  filePicker_dropzonePrimaryText: () => 'Drag-and-Drop',
  filePicker_dropzoneSecondaryText: () => 'Datei auswählen oder hier ablegen',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Dateien auswählen oder hier ablegen',
  filePicker_addFiles: () => 'Dateien hinzufügen',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Erhöhen',
  inputNumber_decrease: () => 'Verringern',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'Keine anzuzeigenden Elemente',
  message_navigationFromMessagesRegion: () =>
    'Meldungsbereich wird geöffnet. Drücken Sie F6, um zum vorherigen fokussierten Element zurückzukehren.',
  message_navigationToMessagesRegion: () =>
    'Meldungsbereich enthält neue Meldungen. Drücken Sie F6, um zum aktuellen Meldungsbereich zu navigieren.',
  messageToast_allMessagesClosed: () => 'Alle Popup-Nachrichten sind geschlossen.'
};
export default bundle;
